import isThrottled from './isThrottled';
import nextTick from './nextTick';

export default function raf(fn) {
	return isThrottled() ? nextTick(fn) : requestAnimationFrame(fn);
}
